import { Vehicle } from '@otw/models'
import { fetchVinData, VINData } from 'core/inventory/fetchVinData'
import { useQuery } from 'react-query'

export const useVinDecoder = (vin: string) => {
  return useQuery<VINData[], Error>(['vinData', vin], () => fetchVinData(vin), {
    enabled: vin.length === 17,
    refetchOnWindowFocus: false,
  })
}

export const isGvwrOver10k = (gvwrString: string): Vehicle['gwvr_over_10k']=> {
  if (!gvwrString) return 'unknown'

  const weightPattern = /([0-9,]+)\s*-\s*([0-9,]+)\s*lb/i
  const singleWeightPattern = /([0-9,]+)\s*lb/i
  const match = gvwrString.match(weightPattern)
  const singleMatch = gvwrString.match(singleWeightPattern)

  if (match && match[1]) {
    const lowerBound = parseInt(match[1].replace(/,/g, ''), 10)
    return lowerBound >= 10000 ? 'yes' : 'no'
  } else if (singleMatch && singleMatch[1]) {
    const weight = parseInt(singleMatch[1].replace(/,/g, ''), 10)
    return weight >= 10000 ? 'yes' : 'no'
  }

  return 'unknown'
}